import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  companyModulesQuery,
  companyOutboundPolicyEventsQuery,
} from '@/entities/company';
import {
  CompanyModuleKeyDto,
  CompanyOutboundPolicyEventsFiltersDto,
  updateCompanyModule,
  UpdateCompanyModuleRequestDto,
} from '@/shared/api/companies';
import { useAppQuery } from '@/shared/lib/useAppQuery';

export function useCompanyModules(companyId: string | undefined) {
  return useAppQuery({
    ...companyModulesQuery(companyId!),
    enabled: Boolean(companyId),
    customError: true,
  });
}

export function useCompanyOutboundPolicyEvents(
  companyId: string | undefined,
  filters: CompanyOutboundPolicyEventsFiltersDto = {}
) {
  return useAppQuery({
    ...companyOutboundPolicyEventsQuery(companyId!, filters),
    enabled: Boolean(companyId),
    customError: true,
  });
}

export function useUpdateCompanyModule(companyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      moduleKey,
      data,
    }: {
      moduleKey: CompanyModuleKeyDto;
      data: UpdateCompanyModuleRequestDto;
    }) => updateCompanyModule(companyId, moduleKey, data),
    onSuccess: (data) =>
      queryClient.setQueryData(companyModulesQuery(companyId).queryKey, data),
  });
}
